const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
  TIMEOUT: 10000, // 10 seconds should be sufficient for 163ms processing
  HEADERS: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};

export default config;